import { render, staticRenderFns } from "./BrowseGoalsResults.vue?vue&type=template&id=13689f7c&scoped=true"
import script from "./BrowseGoalsResults.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsResults.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsResults.vue?vue&type=style&index=0&id=13689f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13689f7c",
  null
  
)

export default component.exports